import {inject} from 'vue'
import {Emitter} from 'mitt'

export const useEmitter = () => {
  return inject('emitter') as Emitter<any>
}
